module.exports = __webpack_public_path__ + "static/media/ic-management.188f2357.svg";